"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _mapMenu = _interopRequireDefault(require("@deosite/helpers/mapMenu"));
var _sortMenuByPosition = _interopRequireDefault(require("@deosite/helpers/sortMenuByPosition"));
var _searchTree2 = _interopRequireDefault(require("@deosite/helpers/searchTree"));
var _rootCategory = require("@deosite/helpers/rootCategory");
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(getUrl, lang) {
    var _searchTree$children_, _searchTree, _menu, _menu$;
    var menu, rootCategory, categoryTree;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _agent.requests.get(global.__appConfig__.menuWithImagesUrl, 1, null, lang);
          case 2:
            menu = _context.sent;
            menu = (_searchTree$children_ = (_searchTree = (0, _searchTree2["default"])(menu, global.__appConfig__.menuSelectByCategoryID, true)) === null || _searchTree === void 0 ? void 0 : _searchTree.children_data) !== null && _searchTree$children_ !== void 0 ? _searchTree$children_ : [];
            rootCategory = (0, _rootCategory.getRootCategory)((_menu = menu) === null || _menu === void 0 ? void 0 : (_menu$ = _menu[0]) === null || _menu$ === void 0 ? void 0 : _menu$.url_path);
            categoryTree = (0, _sortMenuByPosition["default"])((0, _mapMenu["default"])(menu, getUrl));
            return _context.abrupt("return", {
              categoryTree: categoryTree,
              rootCategory: rootCategory
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;